/* eslint-disable no-undef */
/*
 * @Author: snail
 * @Date: 2020-04-02 10:19:34
 * @Last Modified by: snail
 * @Last Modified time: 2020-04-03 09:06:34
 */

const getScriptPath = () => ((document.currentScript ? document.currentScript.src : '') || './').replace(/[^\/]*\.js$/, '');

const AES_SCRIPT_ID = 'aesScript';
const AES_SCRIPT_PATH = `${getScriptPath()}aes-min.js`;

let AES_KEY = '';
let AES_IV = '';

const aesPlugin = {
  init() {
    return new Promise((resolve, reject) => {
      if (!!document.querySelector(`#${AES_SCRIPT_ID}`)) resolve();

      let dom = document.createElement('script');
      dom.id = AES_SCRIPT_ID;
      dom.src = AES_SCRIPT_PATH;
      dom.async = true;
      dom.defer = true;

      document.body.appendChild(dom);

      dom.addEventListener('load', () => {
        dom = null;
        resolve();
      });

      dom.addEventListener('error', () => {
        reject(new Error('加载aes.js失败'));
      });
    });
  },
  /**
   * 生成key和iv
   */
  generateKeyAndIv() {
    return aesPlugin.init().then(data => {
      if (!AES_KEY || !AES_IV) {
        AES_KEY = CryptoJS.enc.Utf8.parse('kryPortalABEFCDG'); // 十六位十六进制数作为密钥
        AES_IV = CryptoJS.enc.Utf8.parse('ABCDE1FKryPortal'); // 十六位十六进制数作为密钥偏移量
      }

      return { key: AES_KEY, iv: AES_IV };
    });
  },
  /**
   * 解密
   * @param {*}} word
   */
  decrypt(word) {
    return aesPlugin
      .generateKeyAndIv()
      .then(data => {
        const { key, iv } = data;
        const decrypted = CryptoJS.AES.decrypt(word, key, {
          iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
        });

        return decrypted.toString(CryptoJS.enc.Utf8);
      })
      .catch(ex => {
        throw new Error('解密失败');
      });
  },

  /**
   * 加密
   * @param {*} word
   */
  encrypt(word) {
    const _word = typeof word === 'string' ? word : word.toString();
    return aesPlugin
      .generateKeyAndIv()
      .then(data => {
        const { key, iv } = data;
        const encrypted = CryptoJS.AES.encrypt(_word, key, {
          iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
        });
        return encrypted.toString();
      })
      .catch(ex => {
        throw new Error('加密失败');
      });
  },
};

const aesHelper = {
  decrypt: aesPlugin.decrypt,
  encrypt: aesPlugin.encrypt,
};

export default aesHelper;



// WEBPACK FOOTER //
// ./src/helper/secure/aes/aesHelper.js